import { HeaderButton } from '@/components/HeaderButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { upgradeFreePlanModalOpen } from '@/components/Modals/UpgradeFreePlanModal';
import { useFreeVideos } from '@/hooks/useFreeVideos';
import Plus from '@/images/plus.svg';
import { createTranslationModalOpen } from '@/pages/translation/state';
import { useAnalytics } from '@/services/analytics';
import { useTheme } from '@mui/material';
import { useSetRecoilState } from 'recoil';

export const CreateButton = () => {
    const mixpanel = useAnalytics();
    const theme = useTheme();
    const setCreateModalOpen = useSetRecoilState(createTranslationModalOpen);
    const { outOfFreeVideos } = useFreeVideos();
    const setUpgradeFreePlanModalOpen = useSetRecoilState(upgradeFreePlanModalOpen);

    const handleClick = () => {
        mixpanel?.track('translate-video', {
            event: 'view',
            from: 'regular',
        });
        if (outOfFreeVideos) {
            setUpgradeFreePlanModalOpen(true);
            return;
        }

        setCreateModalOpen(true);
    };

    return (
        <HeaderButton
            id="translate-video-btn"
            data-testid="translate-video-btn"
            onClick={handleClick}
            aria-label="translate video"
            loadingText="Translate video">
            <MaskedIcon color={theme.colors.black.main} src={Plus} size="16px" />
            Translate video
        </HeaderButton>
    );
};
